<template>
	<section class="section talent bg-offwhite">
    <div class="talent__container">
			<div class="talent-find">
				<h3 class="talent-find__title">Want to see your purpose-driven organisation here?</h3>
      	<p class="talent-find__sub-title">Create a profile and start attracting the talent that will help advance your mission.</p>
				<a class="btn btn-blue-dark" href="/hiring">Find talent</a>
			</div>
			<div class="talent-trusted">
				<h4 class="talent-trusted__title">Trusted by</h4>
				<div class="talent-trusted-images">
					<div class="talent-trusted-image">
						<img :src="`/images/talent/talent--on-purpose.png?${$config.version}`" alt="On-Purpose" width="177" height="28" loading="lazy">
					</div>
					<div class="talent-trusted-image">
						<img :src="`/images/talent/talent--transferwise.png?${$config.version}`" alt="TransferWise" width="90" height="39" loading="lazy">
					</div>
					<div class="talent-trusted-image">
						<img :src="`/images/talent/talent--virgin.png?${$config.version}`" alt="Virgin" width="49" height="51" loading="lazy">
					</div>
					<div class="talent-trusted-image">
						<img :src="`/images/talent/talent--seedrs.png?${$config.version}`" alt="Seedrs" width="110" height="30" loading="lazy">
					</div>
					<div class="talent-trusted-image">
						<img :src="`/images/talent/talent--year-here.png?${$config.version}`" alt="YEAR HERE" width="50" height="50" loading="lazy">
					</div>
					<div class="talent-trusted-image">
						<img :src="`/images/talent/talent--monzo.png?${$config.version}`" alt="Monzo" width="158" height="36" loading="lazy">
					</div>
				</div>
			</div>
    </div>
  </section>
</template>
